module.exports = __webpack_public_path__ + "img/danshuikeng.b9a7005f.png";